<template>
  <div class="navbar yld-framework-navbar">
    <div class="left-menu">
    </div>
    <div class="right-menu">
      <!-- 用户信息 -->
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="hover">
        <div class="avatar-wrapper">
          <el-avatar class="user-avatar" shape="circle" :size="47" fit="fill" :src="avatar || 'https://yldfiles.geekyum.com/fe/imgs/def_logo.png'" alt="用户头像">
          </el-avatar>
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <span>{{ userName }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="yld-dropdown-menu">
          <div>
            <el-dropdown-item @click.native="personal">
              <yun-icon name="icon-renwu" />
              <span>个人设置</span>
            </el-dropdown-item>
            <el-dropdown-item divided @click.native="logout">
              <yun-icon name="icon-dengchu" />
              <span>退出</span>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BASE_URL } from '@yld/yun-utils-host'
import SearchOrder from './SearchOrder/index.vue'
import WarningCheck from './warningCheck'
import { Storage } from '@yld/yun-utils-common'

export default {
  components: {
    SearchOrder,
    WarningCheck
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userinfo'
    ]),
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    userName() {
      return this.userinfo.realName
    }
  },
  mounted() {
    
  },
  data() {
    return {
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      Storage.clearStorage()
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      window.location.replace(BASE_URL.YLD_PASSPORT + '?redirect=' + encodeURIComponent(window.location.href))
    },
    // 个人中心
    personal(){
      if (this.$appId === '90002') {
        const path = this.$route.path
        if (path !== '/90002/personal') {
          this.$router.push('/90002/personal')
        }
      } else {
        window.location.replace(BASE_URL.HOME_WORK+'/90002/personal')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.yld-framework-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left-menu {
    margin-left: 12px;
  }
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    .navbar-download-log {
      margin-left: 16px;
      cursor: pointer;
      color: #333333;
      font-size: 14px;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 16px;
      margin-left: 16px;

      .avatar-wrapper {
        position: relative;
        display: flex;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 100%;
          margin-right: 8px;
        }

        span {
          font-size: 16px;
          color: #333333;
        }
      }
    }
  }
}
.yujing-drawer-form {
  .warning-message {
    background: var(--geek-color-primary);
  }
  .yujing-tips {
    font-size: 14px;
    line-height:28px;
    color: #E59840;
    svg {
      margin-left:10px;
      margin-right: 5px;
    }
  }
  .yujingt-title {
    margin: 6px 0;
    padding-left: 5px;
    border-left: 3px solid var(--geek-color-primary);
    font-size: 14px;
    font-weight: 600;
    line-height:14px;
  }
}
</style>
<style lang="scss">
  .yld-dropdown-menu {
    margin: 0 !important;
    padding: 0 !important;
    .el-dropdown-menu__item {
      //padding: 12px 24px !important;
      line-height: 35px;
      margin: 0;
      svg {
        margin-right: 8px;
      }
    }
    .el-dropdown-menu__item--divided:before {
      content: none
    }
    .el-dropdown-menu__item.el-dropdown-menu__item--divided {
      margin: 0 !important;
    }
  }
  .yujing-drawer-form{
    .el-drawer__body .yun-drawer-form-scroll {
      padding-top: 3px !important
    }
  }
</style>

